import * as validationLib from "./validation";
import isAddressKey from "./isAddressKey";
import getValidationKey from "./getValidationKey";
import {AddressKeys, AppKeys, LookupAppKeys, ReviewKeys, SecuredDepositKeys} from "./api/models";

export enum ValidationType {
    Application = "application",
    Review = "review",
    SecuredBankDeposit = "securedBankDeposit",
    SecuredCardDeposit = "securedCardDeposit",
    SecuredWelcomeBack = "securedWelcomeBack",
}

const ORDERED_FIELDS: string[] = [
    AppKeys.Email,
    AppKeys.FirstName,
    AppKeys.MiddleInitial,
    AppKeys.LastName,
    AddressKeys.AddressLine1,
    AddressKeys.AddressLine2,
    AddressKeys.City,
    AddressKeys.State,
    AddressKeys.Zipcode,
    AppKeys.StudentStatus,
    AppKeys.College,
    AppKeys.PrimaryPhone,
    AppKeys.DateOfBirth,
    AppKeys.SocialSecurity,
    AppKeys.SavingsAccount,
    AppKeys.PaymentAccount,
    AppKeys.AccountTotal,
    AppKeys.AnnualGrossIncome,
    AppKeys.Residency,
    AppKeys.AnnualObligation,
];

const REVIEW_ORDERED_FIELDS: string[] = [ReviewKeys.Text, ReviewKeys.Title, ReviewKeys.Email];

const SECURED_BANK_ORDERED_FIELDS: string[] = [
    SecuredDepositKeys.AbaNumber,
    SecuredDepositKeys.AccountNumber,
    SecuredDepositKeys.ConfirmAccountNumber,
    SecuredDepositKeys.Amount,
];
const SECURED_CARD_ORDERED_FIELDS: string[] = [
    SecuredDepositKeys.CardName,
    AddressKeys.AddressLine1,
    AddressKeys.AddressLine2,
    AddressKeys.City,
    AddressKeys.State,
    AddressKeys.Zipcode,
    SecuredDepositKeys.CardNumber,
    SecuredDepositKeys.CardExpirationDate,
    SecuredDepositKeys.Amount,
];
const SECURED_WELCOME_BACK_ORDERED_FIELDS: string[] = [
    LookupAppKeys.SsnLast4,
    LookupAppKeys.DateOfBirth,
];

export default function getFirstInvalidKey(
    validation: validationLib.Validation,
    validationType: ValidationType,
): string | undefined {
    let firstInvalidKey: string | undefined = undefined;
    if (validation.errors && validationType === ValidationType.Application) {
        firstInvalidKey = ORDERED_FIELDS.find((field) => {
            const key = isAddressKey(field) ? getValidationKey(field) : field;
            return !!validation.errors && !!validation.errors[key];
        });
    } else if (validation.errors && validationType === ValidationType.Review) {
        firstInvalidKey = REVIEW_ORDERED_FIELDS.find((field) => {
            const key = isAddressKey(field) ? getValidationKey(field) : field;
            return !!validation.errors && !!validation.errors[key];
        });
    } else if (validation.errors && validationType === ValidationType.SecuredBankDeposit) {
        firstInvalidKey = SECURED_BANK_ORDERED_FIELDS.find((field) => {
            const key = isAddressKey(field) ? getValidationKey(field) : field;
            return !!validation.errors && !!validation.errors[key];
        });
    } else if (validation.errors && validationType === ValidationType.SecuredCardDeposit) {
        firstInvalidKey = SECURED_CARD_ORDERED_FIELDS.find((field) => {
            const key = isAddressKey(field) ? getValidationKey(field) : field;
            return !!validation.errors && !!validation.errors[key];
        });
    } else if (validation.errors && validationType === ValidationType.SecuredWelcomeBack) {
        firstInvalidKey = SECURED_WELCOME_BACK_ORDERED_FIELDS.find((field) => {
            return !!validation.errors && !!validation.errors[field];
        });
    }
    return firstInvalidKey;
}
